export class ListEffectiveTagsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "DataCatalogTagKind",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DataCatalogTagResourceRef",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEffectiveTagsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
